<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps<{
  title?: string
  description?: string
}>()

const router = useRouter()
const title = computed(() => props.title ?? router.currentRoute.value.meta.name)
const description = computed(() => props.description ?? router.currentRoute.value.meta.description)
</script>

<template>
  <div class="w-full max-h-screen flex flex-col min-w-[992px]">
    <header class="flex flex-row gap-3 px-8 pt-6 bg-inherit">
      <slot name="title">
        <div class="flex flex-col gap-4">
          <h2>{{ title }}</h2>
          <p v-if="description" class="text-base text-text-tertiary">{{ description }}</p>
        </div>
      </slot>
      <div class="flex-1 flex justify-end gap-2">
        <slot name="controls"></slot>
      </div>
    </header>
    <div class="flex flex-row gap-3 px-8 pt-6 bg-inherit">
      <slot name="navigation" />
    </div>
    <main class="flex-1 flex flex-col gap-6 px-8 pb-6">
      <slot />
    </main>
  </div>
</template>
